import { useEffect, useState } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Homepage from "./uiComponents/Homepage";
import Landing from "./uiComponents/Landing";
import userLogin from "./uiComponents/Login";
import Mywallet from "./uiComponents/Mywallet";
import Addcase from "./uiComponents/Addcase";
import Withdraw from "./uiComponents/Withdraw";
import Profile from "./uiComponents/Profile";
import ViewGame from "./uiComponents/ViewGame";
import "animate.css";
import Referralhis from "./uiComponents/Referralhis";
import Refer from "./uiComponents/Refer";
import Notification from "./uiComponents/Notification";
import Support from "./uiComponents/Support";

import Kyc from "./uiComponents/Kyc";

import RefundPolicy from "./uiComponents/RefundPolicy";
import terms_condition from "./uiComponents/terms_condition";
import PrivacyPolicy from "./uiComponents/PrivacyPolicy";
import Gamerules from "./uiComponents/Gamerules";
import ResponsibleGaming from "./uiComponents/ResponsibleGaming";
import Return from "./uiComponents/Return";
import Header from "./Components/Header";
import Rightcontainer from "./Components/Rightcontainer";
import FloatingWhatsapp from "./Components/FloatingWhatsapp";

import Redeem from "./uiComponents/Redeem";
import AboutUs from "./uiComponents/AboutUs";
import socket from "./Components/socket";
import { registerOnMessageListener } from "../services/firebase";
import InAppNotificationPopup from "./Components/InAppNotificationPopup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Maintenence from "./uiComponents/Maintenence";

import History from "./uiComponents/History";
import TDSPolicy from "./uiComponents/TDSPolicy";
import Terms from "./uiComponents/Terms";
import { apiRequest } from "../apiService/allApi";

const App = () => {
  const meeApi = async () => {
    let access_token = localStorage.getItem("token");
    if (!access_token) return;
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(`me`, "GET", null, headers);
      if (res.data) {
        localStorage.setItem("phone", res.data.Phone);
      }
    } catch (e) {}
  };
  useEffect(() => {
    meeApi();
  }, []);

  const access_token = localStorage.getItem("token");
  const [userData, setUser] = useState();

  const [allplay, setallPlay] = useState([]);

  const [activeNotification, setActiveNotification] = useState(null);
  const [settinData, setSettingData] = useState(undefined);

  useEffect(() => {
    const UserId = localStorage.getItem("userId");
    socket.on("websettingGet", (data) => {
      localStorage.setItem("sitSetting", JSON.stringify(data));
      setSettingData(data);
    });
    socket.emit("getgamelist", UserId);
    socket.on("setGamelist", (data) => {
      setallPlay(data);
    });

    socket.on("disconnect", (data) => {
      socket.emit("joinUser", access_token);
    });
    socket.on("setProfile", (data) => {
      setUser(data);
      localStorage.setItem("userId", data?._id);
      localStorage.setItem("udata", JSON.stringify(data));
    });
  }, [socket]);

  useEffect(() => {
    socket.emit("joinUser", access_token);
    socket.emit("websetting", "");
    socket.emit("getprofile", access_token);
  }, [socket]);

  useEffect(() => {
    const unsubscribe = registerOnMessageListener((payload) => {
      console.log("Push notification received in foreground:", payload);
      const title =
        payload?.notification?.title ||
        payload?.data?.title ||
        "King Mastar";
      const body =
        payload?.notification?.body ||
        payload?.data?.body ||
        payload?.data?.message ||
        "";
      const image =
        payload?.notification?.image ||
        payload?.data?.image ||
        "";

      setActiveNotification({
        title,
        body,
        image,
      });
    });

    return () => {
      if (typeof unsubscribe === "function") {
        unsubscribe();
      }
    };
  }, []);

  const styles = {
    backgroundColor: "#fff",
    color: "black",
  };

  const [open, setOpen] = useState(true);

  useEffect(() => {
    socket.on("setProfile", (data) => {
      setOpen(data?.superUser);
      localStorage.setItem("udata", JSON.stringify(data));
    });
  }, [socket]);

  return (
    <>
      {JSON.parse(localStorage.getItem("sitSetting")) == "undefined" ? (
        ""
      ) : JSON.parse(localStorage.getItem("sitSetting"))?.siteMaintenance ===
          true || open == false ? (
        <div>
          <Maintenence />
        </div>
      ) : (
        <>
          <Header user={userData} />

          {!access_token ? (
            <Switch>
              <Route exact path="/" component={Landing} />
              <Route path="/landing" component={Landing} />
              <Route path="/login/:referralcode?" component={userLogin} />

              <Route path="/RefundPolicy" component={RefundPolicy} />
              <Route path="/privacy-policy" component={PrivacyPolicy} />
              <Route path="/term-condition" component={terms_condition} />
              <Route path="/tds-policy" component={TDSPolicy} />
              <Route path="/about" component={AboutUs} />
              <Route path="/refund-policy" component={RefundPolicy} />
              <Route path="/Terms" component={Terms} />
              <Route path="/contact-us" component={Support} />
              <Route path="/Gamerules" component={Gamerules} />
              <Route path="/responsible-gaming" component={ResponsibleGaming} />

              <Redirect to="/login" />
            </Switch>
          ) : (
            <Switch>
              <Route exact path="/Referral-history" component={Referralhis} />

              <Route
                path="/landing"
                render={() => <Landing userAllData={userData} />}
              />
              <Route exact path="/history" component={History} />

              <Route
                exact
                path="/HomePage/:Game/:type?"
                render={() => (
                  <Homepage
                    homePlay={allplay}
                    setsocket={socket}
                    users={userData}
                  />
                )}
              />

              <Route
                exact
                path={["/refer", "/Refer"]}
                render={() => <Refer user={userData} />}
              />
              <Route exact path="/Notification" component={Notification} />
              <Route exact path="/" component={Landing} />

              <Route
                path="/profile"
                render={() => <Profile profile={userData} />}
              />
              <Route
                path="/viewgame/:id"
                render={(props) => <ViewGame {...props} userData={userData} />}
              />

              <Route path="/addcase" render={() => <Addcase />} />

              <Route path="/withdraw" render={() => <Withdraw />} />
              <Route
                path="/wallet"
                render={() => <Mywallet user={userData} />}
              />

              <Route path="/support" component={Support} />

              <Route exact path="/landing/:id" component={Landing} />
              <Route
                path={["/kyc", "/Kyc"]}
                render={() => <Kyc user={userData} />}
              />
              <Route path="/Rules" component={Gamerules} />
              <Route path="/RefundPolicy" component={RefundPolicy} />
              <Route path="/privacy-policy" component={PrivacyPolicy} />
              <Route path="/term-condition" component={terms_condition} />
              <Route path="/tds-policy" component={TDSPolicy} />

              <Route path="/return" render={() => <Return />} />

              <Route path="/Redeem" render={() => <Redeem />} />
              <Route path="/contact-us" component={Support} />
              <Route path="/refund-policy" component={RefundPolicy} />
              <Route path="/Gamerules" component={Gamerules} />
              <Route path="/responsible-gaming" component={ResponsibleGaming} />
              <Route path="/about" component={AboutUs} />
              <Route path="/maint" component={Maintenence} />

              <Redirect to="/landing" />
            </Switch>
          )}

          <Rightcontainer />

          <FloatingWhatsapp />

          <InAppNotificationPopup
            notification={activeNotification}
            onClose={() => setActiveNotification(null)}
          />

          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </>
      )}
    </>
  );
};
export default App;
